import React from 'react';
import styled, { css, keyframes } from 'styled-components';

interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  isLoading?: boolean;
  isMobile?: boolean;
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.5);
  border-top: 4px solid lightgrey;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: ${spin} 1s linear infinite;
  display: block;
  margin: auto;
`;

const StyledButton = styled.button<IButton>`
  text-align: center;
  background-color: ${(props) => props.theme.colors.secondary};
  padding: 0 2.5rem;
  height: 50px;
  border-radius: 25px;
  font-weight: bold;
  cursor: pointer;
  border: 2px solid ${(props) => props.theme.colors.textSecondary};
  width: max-content;
  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.5;
          cursor: default;
        `
      : css`
          :hover {
            background: ${(props) => props.theme.colors.textSecondary};
            border: 2px solid ${(props) => props.theme.colors.textPrimary};
            color: ${(props) => props.theme.colors.textPrimary};
          }
        `}
  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 100%;
    `}
  ${(props) =>
    props.primary &&
    css`
      background-color: ${(props) => props.theme.colors.primary};
    `};
  ${(props) =>
    props.isLoading &&
    css`
      pointer-events: none;
    `};
  color: ${(props) => props.theme.colors.textSecondary};
`;

const Button: React.FC<IButton> = ({ isMobile = false, ...props }) => {
  return (
    <StyledButton isMobile={!!isMobile} {...props}>
      {props.isLoading ? <Spinner /> : props.children}
    </StyledButton>
  );
};

export default Button;
